// desegurocompras.js
import router from "@/router"
import Swal from 'sweetalert2/dist/sweetalert2'

const localizacionStorage = localStorage.getItem('localizacion') ? JSON.parse(localStorage.getItem('localizacion')) : null

export default {
    state: {
        // DESEGUROCOMPRAS
        ds_categorias_departamento: [],
        ds_departamento: {},
        filtersDs: {
            tipo: 'created_at',
            min: null,
            max: null,
            off: false,
            inMyCity: false,
            location: {
                city: localizacionStorage ? localizacionStorage.municipio : null,
                cityId: localizacionStorage ? localizacionStorage.id_muni :  null,
                regionId:localizacionStorage ?  localizacionStorage.id_edo :  null,
                abrev: localizacionStorage ? `${localizacionStorage.municipio}, ${localizacionStorage.edo_av}` :  null
            },
        },
        title_menu_ds: '',
        path_back_ds: '',
        show_menu_ds: true,
        show_preventas: false,
        show_negocios_patrocinadores: false,
        show_header_ds: true,
        carrito: JSON.parse(localStorage.getItem('cart_products')) || [],
        ds_busqueda: localStorage.getItem('ds_busqueda') || '',
        localizacion: localizacionStorage,
        envios: [],
        categorias: null,
        categoria: null,
        medios_pago: [],
        query_ds: '',
        //Objeto con ids de sucursales como llaves, cada valor es un arreglo de IDs de productos
        carroSucursal: JSON.parse(localStorage.getItem('carroSucursal')) || {},
        //Arreglo de IDs de productos marcados como favoritos
        favoritos: JSON.parse(localStorage.getItem('favoritos')) || [],

        //Para actualizar el estado de las publicaciones a través de modales en la vista de detalles de sucursal
        updateStatusPublicacion: null,

        //Indica si el componente de búsqueda de ubicación está activo
        chosingUbicacion: false
    },
    mutations: {
        SET_SHOW_MENU_DS(state, {show_menu, path = null}) {
            state.show_menu_ds = show_menu
            state.path_back_ds = path
        },
        SET_SHOW_HEADER_DS(state, show_header) {
            state.show_header_ds = show_header
        },
        SET_TITLE_MENU_DS(state, title_menu) {
            state.title_menu_ds = title_menu
        },
        setFiltersSearchDs(state, filters) {
            state.filtersDs = filters
        },
        SET_CARRITO(state, datos) {
            state.carrito = datos
        },
        SET_ENVIOS(state, envios) {
            state.envios = envios
        },
        SET_PUBLICACIONES_OFF(state, status) {
            state.publicaciones_off = status
        },
        SET_DESCUENTOS_PUBLICACIONES(state, status) {
            state.filtersDs.off = status
        },
        SET_VIEW_PAQUETES(state, status) {
            state.filtersDs.paquetes = status
        },
        SET_VIEW_PREVENTAS(state, status) {
            state.show_preventas = status
        },
        SET_VIEW_NEGOCIOS_PATROCINADORES(state, status) {
            state.show_negocios_patrocinadores = status
        },
        SET_METODOS_PAGO(state, pagos) {
            state.metodos_pago = pagos
        },
        SET_PUBLICACION_PROMOCIONES(state, publicacion) {
            state.publicacion_promociones = publicacion
        },
        SET_CATEGORIAS(state, categorias) {
            state.categorias = categorias
        },
        SET_CATEGORIA(state, categoria) {
            state.categoria = categoria
        },
        SET_QUERY_DS(state, query) {
            $("#input-search").val(query);
            state.query_ds = query
        },

        SET_DS_CATEGORIAS_DEPARTAMENTO(state, query) {
            state.ds_categorias_departamento = query
        },

        SET_DS_DEPARTAMENTO(state, query) {
            state.ds_departamento = query
        },

        SET_DEPARTAMENTO_PUBLICACIONES(state, publicaciones) {
            state.departamento_publicaciones = publicaciones
        },

/*
        Añadir a carro de productos de establecimiento en sucursal
        ids: {sucursalId,productId}
*/
        ADD_TO_CARRO_SUCURSAL(state,ids) {
            if (typeof state.carroSucursal[ids.sucursalId] === 'undefined') {
                state.carroSucursal[ids.sucursalId] = []
            }
            state.carroSucursal[ids.sucursalId].push(Number(ids.productId))
            localStorage.setItem('carroSucursal', JSON.stringify(state.carroSucursal))
        },
/*
        Remover del carro de productos de establecimiento en sucursal
        ids: {sucursalId,productId}
*/
        REMOVE_FROM_CARRO_SUCURSAL(state,ids) {
            if (typeof state.carroSucursal[ids.sucursalId] !== 'undefined') {
                const index = state.carroSucursal[ids.sucursalId].indexOf(ids.productId)
                if (index > -1) {
                    state.carroSucursal[ids.sucursalId].splice(index,1)
                    localStorage.setItem('carroSucursal', JSON.stringify(state.carroSucursal))
                }
            }
        },
        REMOVE_SUCURSAL_FROM_CARRO_SUCURSAL(state,id) {
            if (typeof state.carroSucursal[id] !== 'undefined') {
                state.carroSucursal[id].length = 0
                localStorage.setItem('carroSucursal', JSON.stringify(state.carroSucursal))
            }
        },
        REMOVE_EMPTY_FROM_CARRO_SUCURSAL(state) {
            for (let key in state.carroSucursal) {
                if (state.carroSucursal.hasOwnProperty(key) && state.carroSucursal[key].length === 0) {
                    delete state.carroSucursal[key]
                }
            }
            localStorage.setItem('carroSucursal', JSON.stringify(state.carroSucursal))
        },
        SET_CARRO_SUCURSAL(state,obj) {
            state.carroSucursal = obj
            localStorage.setItem('carroSucursal', JSON.stringify(state.carroSucursal))
        },

        //Añadir a favoritos
        ADD_TO_FAVORITOS(state,id) {
            if(!state.favoritos.includes(id)) {
                state.favoritos.push(Number(id))
                localStorage.setItem('favoritos', JSON.stringify(state.favoritos))
            }
        },
        //Quitar de favoritos
        REMOVE_FROM_FAVORITOS(state,id) {
            const index = state.favoritos.indexOf(id)
            if (index > -1) {
                state.favoritos.splice(index,1)
                localStorage.setItem('favoritos', JSON.stringify(state.favoritos))
            }
        },
        //Establecer el arreglo completo de favoritos
        SET_FAVORITOS(state,array) {
            state.favoritos = array
            localStorage.setItem('favoritos', JSON.stringify(state.favoritos))
        },

        SET_UPDATE_STATUS_PUBLICACION(state,obj) {
            state.updateStatusPublicacion = obj
        },

        SET_LOCALIZACION(state,localizacion) {
            state.localizacion = localizacion
            state.filtersDs.location = {
                city: localizacion ? localizacion.municipio : null,
                cityId: localizacion ? localizacion.id_muni : null,
                regionId: localizacion ? localizacion.id_edo : null,
                abrev: localizacion ? `${localizacion.municipio}, ${localizacion.edo_av}` : null
            }
            if (localizacion) {
                localStorage.setItem('localizacion', JSON.stringify(localizacion))
            } else {
                localStorage.removeItem('localizacion')
            }
        },

        SET_CHOSING_UBICACION(state, bool) {
            state.chosingUbicacion = bool
        }
    },
    actions: {
        // Actions go here if needed
        add_carrito({commit}, item) {
            if (typeof (Storage) !== 'undefined') {
                let agregado_a_carrito = false
                const storage = (localStorage.getItem('cart_products')) ? JSON.parse(localStorage.getItem('cart_products')) : []
                const negocio_id = item.negocio_id

                let negocio_carrito = storage.find(element => element.id === negocio_id)
                item["cantidad"] = 1

                if (typeof negocio_carrito !== 'undefined'){
                    const negocio_products = negocio_carrito.negocio_products
                    const producto_repetido = negocio_products.some(p => p.id === item.id && p.en_preventa === item.en_preventa)

                    if (producto_repetido) {
                        Swal.fire({
                            icon: 'info',
                            title: 'Oops...',
                            html: "<div class='text-light'> <span class='text-medium' style='font-size: 11px;'> <img style='border-radius: 10px; width: 92px; height: 92px;' src='" +item.image_url +"' alt=''> <br>"  + item.nombre + " <br> <span class='fg-orange text-upper text-medium'> Ya ha sido agregado previamente a tu carrito</span></span></div> <br>",
                            showCancelButton: true,
                            reverseButtons: true,
                            confirmButtonColor: '#56a027',
                            cancelButtonColor: '#504949',
                            confirmButtonText: 'Ir a carrito',
                            cancelButtonText: 'Seguir comprando'
                        }).then((result) => {
                            if (result.isConfirmed) {
                                router.push({path: '/desegurocompras/carrito'})
                            }
                        })
                    } else {
                        agregado_a_carrito = true
                        negocio_products.push(item)
                    }
                } else {
                    agregado_a_carrito = true
                    const negocio_products = [item]
                    const negocio_carrito = {id: negocio_id, subdominio: item.subdominio,
                        negocio_products: negocio_products}
                    storage.push(negocio_carrito)
                }

                if (agregado_a_carrito){
                    Swal.fire({
                        title: 'Agregado!',
                        html: "<div class='text-light'> <span class='text-medium' style='font-size: 11px;'> <img style='border-radius: 10px; width: 92px; height: 92px;' src='" +item.image_url +"' alt=''> <br>" + item.nombre + "</span></div> <br>",
                        icon: 'success',
                        showCancelButton: true,
                        reverseButtons: true,
                        confirmButtonColor: '#56a027',
                        cancelButtonColor: '#504949',
                        confirmButtonText: 'Ir a carrito',
                        cancelButtonText: 'Seguir comprando'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            router.push({path: '/desegurocompras/carrito'})
                        }
                    })
                }

                localStorage.setItem('cart_products', JSON.stringify(storage))
                commit("SET_CARRITO", storage)
            } else {
                // Código cuando Storage NO es compatible
            }
        },
        remove_item({commit}, p) {
            if (localStorage.getItem('cart_products')) {
                const car_local = JSON.parse(localStorage.getItem('cart_products'))
                const negocio_carrito = car_local.find(element => element.id === p.negocio_id)

                if (typeof negocio_carrito !== 'undefined') {
                    const indexes = negocio_carrito.negocio_products.reduce((arr, value, index) => {
                        if (value.id === p.id && value.en_preventa === p.en_preventa ) {
                            arr.push(index)
                        }
                        return arr
                    }, [])
                    indexes.forEach((i,index) => {
                        negocio_carrito.negocio_products.splice(i - index, 1)
                    })

                    //Borrar carro del negocio si queda vacío
                    if (negocio_carrito.negocio_products.length === 0){
                        const index = car_local.findIndex(el => el.id === negocio_carrito.id)
                        car_local.splice(index,1)
                    }
                }
                localStorage.setItem('cart_products', JSON.stringify(car_local))
                commit("SET_CARRITO", car_local)
            }
        },
        increment({commit}, payload) {
            const cantidad = parseInt(payload.cantidad)
            const id = payload.id
            const carrito = (localStorage.getItem('cart_products')) ? JSON.parse(localStorage.getItem('cart_products')) : []
            carrito.forEach((i, index) => {
                if (i.id == id) {
                    if ((i.cantidad < i.existencia) || i.stock_ilimitado || cantidad > 0) {
                        if (cantidad > 0) {
                            if ((cantidad <= i.existencia) || i.stock_ilimitado) {
                                carrito[index].cantidad = cantidad
                            }
                        } else {
                            carrito[index].cantidad = Number(carrito[index].cantidad) + 1
                        }
                    }
                }
            })
            localStorage.setItem('cart_products', JSON.stringify(carrito))
            commit("SET_CARRITO", carrito)
        },
        decrement({commit}, id) {
            const storage = (localStorage.getItem('cart_products')) ? JSON.parse(localStorage.getItem('cart_products')) : []
            const cantidad = storage.find(function (element, i) {
                if (element.id == id) {
                    if (element.cantidad > 1) {
                        storage[i].cantidad -= 1
                    }
                } else {
                    return false
                }
            });
            localStorage.setItem('cart_products', JSON.stringify(storage))
            commit("SET_CARRITO", storage)
        }
    },
    getters: {
        categoria: state => state.categoria,
        categorias: state => state.categorias,
        carrito: state => state.carrito,
        ds_busqueda: state => state.ds_busqueda,
        localizacion: state => state.localizacion,

        filtersSearch: state => state.filtersDs,
        queryDs: state => state.query_ds,
        carroSucursal: state => state.carroSucursal,
        carroSucursalById: state => (id) => {
            if (typeof state.carroSucursal[id] === 'undefined') {
                state.carroSucursal[id] = []
            }
            return state.carroSucursal[id]
        },
        favoritos: state => state.favoritos,
        updateStatusPublicacion: state => state.updateStatusPublicacion,
        chosingUbicacion: state => state.chosingUbicacion
    }
};

